<template>
  <div id="hideContainer">
    <div class="statistic_row">
      <div class="tatisticButton" @click="showFilterClick">
        <div class="statisticsButtonDiv"><pt-icon type="icon-tongji1"  class="statisticsButton"></pt-icon></div>
        <div :class="showFilter ? 'activeBtn':'btn-contain'">
          <div class="moreQueryBtn">
            <a-icon type="caret-up" :class="showFilter ? '': 'toggleIcon'"></a-icon>
          </div>
        </div>
      </div>
      <div v-show="showFilter" style="flex:1;margin: 20px 0;">
        <slot name="hideContent"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ptHideContainer',
    props: {

    },
    data() {
      return {
        showFilter: false,
        disableShow: false,
      }
    },
    mounted() {

    },
    methods: {
      hideRow(){
        this.showFilter = false;
      },
      showFilterClick(){
        if(!this.disableShow){
          if(this.showFilter){
            this.showFilter = false;
          }else{
            this.showFilter = true;
            this.$emit('hideOther');
          }
        }else{
          this.$message.warning("请先选择公司!")
        }
      },
      disableRow(){
        this.hideRow()
        this.disableShow = true
      },
      enableRow(){
        this.disableShow = false
      }
    }
  }
</script>

<style scoped lang="less">
  .statistic_row{
    position:relative;
    margin-bottom: 4px;
    .tatisticButton{
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .statisticsButtonDiv{
        .statisticsButton{
          font-size: 18px; color: #BEC2D6;
        }
        .statisticsButton :hover{
          color: #FABE00;
        }
        .statisticsButton :active{
          color: #FABE00;
        }
      }
    }
    .btn-contain{
      border-right: 2px solid #F4F5F8;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .activeBtn{
      border-right: 2px solid #F4F5F8;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
    }
    .moreQueryBtn{
      position:relative;
      flex: 1;
      font-size: 14px;
      color: #999999;
      margin: 0 20px;
      cursor: pointer;
    }
    .moreQueryButton{
      width: 250px;
    }
    .toggleIcon{
      transform: rotate(180deg);
    }
    display: flex;
    flex-direction: row;
  }
</style>